// extracted by mini-css-extract-plugin
var _1 = "PJEAt9";
var _2 = "TCbiY5";
var _3 = "Gf3GNb";
var _4 = "iwtZf8";
var _5 = "rJcn08";
var _6 = "XTGvt7";
var _7 = "N84MwM";
var _8 = "JYUM1A";
var _9 = "GNZKaM";
var _a = "vjWGVb";
var _b = "XJbkOv";
var _c = "szcmxs";
var _d = "KUJA32";
var _e = "GdpMYI";
var _f = "tdwKkK";
var _10 = "iHY_Nx";
var _11 = "klcBYr";
var _12 = "YTrVBT";
export { _1 as "absolute", _2 as "close", _3 as "color-alien", _4 as "color-drive", _5 as "color-fargo", _6 as "color-indiana", _7 as "color-lebowski", _8 as "color-matrix", _9 as "color-rocky", _a as "color-snatch", _b as "ease-transition", _c as "gradient-titanic-80", _d as "linear-transition-05", _e as "shadow-medium-titanic", _f as "shadow-medium-titanic-hover", _10 as "shadow-titanic-1", _11 as "shadow-white", _12 as "tag" }
